/* eslint-disable @typescript-eslint/no-empty-function */
import { EditorEvent, InlineEditState } from '../constants';
import { Command, Edge, Graph, Item, Node } from '../types';
import { getSelectedEdges, getSelectedNodes, isMind, setSelectedItems } from '../utils';

export interface BaseCommand<P = Record<string, unknown>, G = Graph> extends Command<P, G> {
  /** Determind whether this is a mind map */
  isMind(graph?: G): boolean;
  /** Get selected node */
  getSelectedNodes(graph: G): Node[];
  /** Get selected connection */
  getSelectedEdges(graph: G): Edge[];
  /** Set selected element */
  setSelectedItems(graph: G, items: Item[] | string[]): void;
  /** Edit the selected node */
  editSelectedNode(graph: G): void;
}

export const baseCommand: BaseCommand = {
  name: '',

  params: {},

  canExecute() {
    return true;
  },

  shouldExecute() {
    return true;
  },

  canUndo() {
    return true;
  },

  init() {},

  execute() {},

  undo() {},

  shortcuts: [],

  isMind,

  getSelectedNodes,

  getSelectedEdges,

  setSelectedItems,

  editSelectedNode(graph) {
    graph.emit(EditorEvent.onInlineEditStateChange, {
      inlineEditState: InlineEditState.Show,
      item: getSelectedNodes(graph)[0],
    });
  },
};
